import React, {ReactNode, useEffect, useState} from "react";
import {Button, ButtonTypes} from "./buttons";
import {Icon} from "./icon";
import './Dropdown.sass';
import Input from "./Input";
import translate from "../../../../translate";

type DropdownProps = {
    buttonTypes: ButtonTypes[],
    value: string,
    onChange: (value: string) => void,
    options: Record<string, ReactNode>,
    placeholder?: ReactNode,
    searchable?: boolean,
    matchesSearchTerm?: (key: string, searchTerm: string) => boolean,
}

export function Dropdown<T>(props: DropdownProps) {
    const { buttonTypes, value, options, onChange, placeholder, searchable, matchesSearchTerm } = props;
    const [ active, setActive ] = useState<boolean>(false);
    const [ searchTerm, setSearchTerm ] = useState<string>('');

    function onChangeHandler(key: string): void {
        onChange(key);
        setActive(false);
        setSearchTerm('');
    }

    function _matchesSearchTerm(key: string): boolean {
        if (matchesSearchTerm !== undefined) {
            return matchesSearchTerm(key, searchTerm);
        } else {
            return key.toLowerCase().includes(searchTerm);
        }
    }

    return <>
        { active && <div className='dropdownBlurCatcher' onClick={() => setActive(false)}></div> }
        <div className={'dropdown-react ' + (active ? 'active' : '')}>
            {
                (!searchable || !active) &&
                <Button buttonTypes={buttonTypes} onClick={() => setActive(!active)} className='dropdown-toggle'>
                    <div className='dropdownCurrentContent'>
                        <div>{value === null ? placeholder : options[value]}</div>
                        <div><Icon type={'caret'}/></div>
                    </div>
                </Button>
            }
            {
                (searchable && active) && <div>
                    <Input value={searchTerm} placeholder={translate('react/component/Dropdown/search')} autoFocus={true} onChange={e => setSearchTerm(e.target.value)} />
                </div>
            }
            <ul className='menu'>
                {
                    Object.entries(options)
                        .filter(([key]) => _matchesSearchTerm(key))
                        .map(([key, value]) => <li key={key} className='menu-item' onClick={() => onChangeHandler(key)}>
                            <a onClick={e => e.preventDefault()}>
                                {value}
                            </a>
                        </li>)
                }
            </ul>
        </div>
    </>
}
